<template>
<div>
  <b-modal v-bind:id="modId" v-bind:title="this.$i18n.t('header.link_password_change')" hide-footer>
    <p class="my-4">{{ $i18n.t("menu.change_password_message") }}</p>
      <label for="inputFormerPassword" class>{{ $i18n.t("menu.former_password") }}</label>
      <b-form-input id="inputFormerPassword" v-model="inputFormerPassword" type="password" class="mb-3"></b-form-input>
      <label for="inputChangedPassword" class>{{ $i18n.t("menu.changed_password") }}</label>
      <b-form-input id="inputChangedPassword" v-model="inputChangedPassword" type="password" class="mb-3"></b-form-input>
      <label for="inputConfirmationPassword" class>{{ $i18n.t("menu.comfirmation_password") }}</label>
      <b-form-input id="inputConfirmationPassword" v-model="inputConfirmationPassword" type="password" class="mb-3"></b-form-input>
    <b-button variant="primary" block @click='changePass'>{{ $i18n.t("menu.change") }}</b-button>
    <b-button block @click='cancel'>{{ $i18n.t("common.cancel") }}</b-button>
  </b-modal>
</div>
</template>
<script>
import confirmModal from '../ConfirmModal'
export default {
  components: {
    confirmModal
  },
  data () {
    return {
      errMsg: null,
      errSbj: null,
      inputFormerPassword: this.$parent.inputFormerPassword,
      inputChangedPassword: this.$parent.inputChangedPassword,
      inputConfirmationPassword: this.$parent.inputConfirmationPassword
    }
  },
  name: 'Modal',
  props: ['modId', 'titleMsg', 'msg', 'buttonMsg'],
  methods: {
    changePass: function () {
      this.$parent.inputFormerPassword = this.inputFormerPassword
      this.$parent.inputChangedPassword = this.inputChangedPassword
      this.$parent.inputConfirmationPassword = this.inputConfirmationPassword
      this.$parent.modalResult = true
      this.confirmModal()
    },
    cancel: function () {
      this.$bvModal.hide('md-changePass')
    },
    confirmModal () {
      this.$emit('confirm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/ChangePassModal.vue